export const CHAT_ACTIVITY_LOAD = 'CHAT_ACTIVITY_LOAD';
